import React from 'react'
import Link from 'gatsby-link'

import AHref from '../../components/AHref'

import './index.scss'

class Header extends React.Component {

  render() {
    return (
      <header className="heading inner">
        <div className="row">
          <div className="col-xs-6 col-sm-8">
            <h5><Link to="/" exact>Natalie Johnson</Link></h5>
          </div>
          <div className="col-xs-10 col-sm-8">
            <h5 className="text-right-sm"><AHref url="mailto:natalie@nataliejohnson.com">natalie@nataliejohnson.com</AHref></h5>
          </div>
        </div>
      </header>
    );
  }
}

export default Header



// WEBPACK FOOTER //
// ./src/components/Header/index.js